import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container';
import HeaderLogo from './HeaderLogo';
import HeaderMenu from './HeaderMenu';
import HeaderSearchBar from './HeaderSearchBar';
import HeaderModals from './HeaderModals';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

export default function Header() {
    return (<>
        <Navbar expand="xl" className='bg-body  border-top pb-2 border-warning border-5'>
            <Container fluid className='p-0'>
                <Row className='w-100'>
                    <Col xs={10} sm={{ span: "auto", order: 0 }} xl={"auto"} className='ps-4 pt-2'>
                        <HeaderLogo />
                    </Col>
                    <Col xs={2} sm={{ span: "auto", order: 4 }} className='mt-2 d-xl-none'>
                        <Navbar.Toggle className='rounded-0 border-0' aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" >
                            <Image src={'/assets/hamburger.svg'} width={28} />
                        </Navbar.Toggle>
                    </Col>
                    <Col xs={12} sm={{ span: 12, order: 5 }} xl={{ span: "auto", order: 1 }}>
                        <HeaderMenu />
                    </Col>
                    <Col xs={10} sm={{ span: true, order: 1 }} xl={true} className='mt-2 ps-4'>
                        <HeaderSearchBar />
                    </Col>
                    <Col xs={2} sm={{ span: "auto", order: 2 }} xl={"auto"} className='mt-2 p-0 ps-3 ps-xl-1'>
                        <HeaderModals />
                    </Col>
                </Row>
            </Container>
        </Navbar>
    </>)
}